<template>
  <div class="guest-type-list-wrapper">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="全部分组" name="all">
        <div class="tabs">
          <div class="tab-item" v-for="(tab, i) in tabs" :key="i">
            <div class="tab-header">
              <el-checkbox v-model="tab.checked" @change="onCheckChange">{{ tab.name }}</el-checkbox>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getGuestCategories } from "@/api/guest";

export default {
  data() {
    return {
      tabs: [],
      activeTab: 'all',
      loading: false,
    }
  },
  created() {
    this.getList();
  },
  methods: {
    onCheckChange() {
      // 触发父组件事件通知变化
      this.$emit('change', this.getCheckedList());
    },
    
    async getList() {
      try {
        this.loading = true;
        const response = await getGuestCategories();
        
        if (response.status === '10000') {
          this.tabs = response.data.categories.map((item) => ({
            checked: false,
            ...item
          }));
        } else {
          this.$message.error(response.message || '获取嘉宾分组失败');
        }
      } catch (error) {
        this.$message.error('获取嘉宾分组失败');
        console.error('获取嘉宾分组失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    getCheckedList() {
      // 返回选中的分组
      return this.tabs.filter(tab => tab.checked);
    },
    
    // 预先选择分组
    selectItems(items) {
      if (!items || !items.length) return;
      
      // 重置所有选择状态
      this.tabs.forEach(tab => {
        tab.checked = false;
      });
      
      // 设置传入项的选中状态
      items.forEach(item => {
        const tabIndex = this.tabs.findIndex(tab => tab._id === item._id);
        if (tabIndex !== -1) {
          this.tabs[tabIndex].checked = true;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.guest-type-list-wrapper {
  width: 100%;
  height: 100%;
  
  .tabs {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    
    .tab-item {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      
      .tab-header {
        padding: 10px;
        background-color: #f5f7fa;
        border-bottom: 1px solid #ebeef5;
        font-weight: bold;
      }
    }
  }
}
</style> 